<select 
    class="form-control"
    [name]="name"
    [id]="id"
    [required]="required"
    [disabled]="disabled"
    [ngModel]="ngModel || ''"
    (ngModelChange)="onChange($event ? $event : null)">
    <option value="" *ngIf="canSelectNull || (required && !ngModel)">
        {{nullLabel}}
    </option>
    <option *ngFor="let tipo of tipos" [ngValue]="tipo.id">{{tipo.nome | uppercase}}</option>
</select>